import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RestaurantState {
  data: {
    displayName: string;
    id: string;
    location: {
      latitude: number;
      longitude: number;
    };
    imageUrl: string;
    openingTime: string;
    closingTime: string;
  } | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: RestaurantState = {
  data: null,
  isLoading: false,
  error: null,
};


export const restaurantSlice = createSlice({
  name: "restaurant",
  initialState,
  reducers: {
    fetchRestaurantStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchRestaurantSuccess: (
      state,
      action: PayloadAction<RestaurantState["data"]>
    ) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchRestaurantFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearRestaurant: (state) => {
      state.data = null;
      state.isLoading = false;
      state.error = null;
    }
  },
});


export const {
  fetchRestaurantStart,
  fetchRestaurantSuccess,
  fetchRestaurantFailure,
  clearRestaurant
} = restaurantSlice.actions;

export default restaurantSlice.reducer;
